import { Box, Typography, styled } from "@mui/material";
import React, { useMemo } from "react";

import { DefaultUrlWeb } from "config/Configuration";
import NumberFormats from "components/NumberFormats";
import { WALLET_TYPE } from "pages/BasicTrade/components/constants";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";

function PortfolioDetail() {
  const portfolioChart = useSelector(
    (state) => state.portfolio.portfolioChart?.data
  );

  const [searchParams] = useSearchParams();
  const walletTypeId =
    +searchParams.get("walletTypeId") || WALLET_TYPE.spot;

  const title = useMemo(
    () =>
      walletTypeId === WALLET_TYPE.spot
        ? "Spot Wallet"
        : "Margin Wallet",
    [walletTypeId]
  );

  return (
    <PortfolioDetailWrapper>
      <Typography variant="h5" mb={1}>
        {title}
      </Typography>

      <Typography
        sx={{ mb: 2 }}
        variant="h6"
        fontWeight={400}
        color="text.main"
      >
        Total Asset Value:
      </Typography>

      <BoxStyle mb={2}>
        <img src={DefaultUrlWeb + `/images/coin/usdt.png`} alt="USDT" />

        <Typography ml={1.5} variant="h6" color="text.main" fontWeight={400}>
          <NumberFormats value={portfolioChart?.creditCostMarketUSDT} />

          <Typography
            ml={1}
            color="text.secondary"
            variant="subtitle1"
            component="small"
            fontWeight={300}
          >
            USDT
          </Typography>
        </Typography>
      </BoxStyle>

      <BoxStyle mb={3}>
        <img src={DefaultUrlWeb + `/images/coin/toman.png`} alt="Toman" />

        <Typography ml={1.5} variant="h6" color="text.main" fontWeight={400}>
          <NumberFormats value={portfolioChart?.creditCostMarketToman} />

          <Typography
            ml={1}
            color="text.secondary"
            variant="subtitle1"
            component="small"
            fontWeight={300}
          >
            TOMAN
          </Typography>
        </Typography>
      </BoxStyle>
    </PortfolioDetailWrapper>
  );
}

const BoxStyle = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",

  img: {
    width: "25px",
    height: "25px",
  },
}));

const PortfolioDetailWrapper = styled(Box)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.modules.border}`,
  paddingTop: theme.spacing(2),
}));

export default PortfolioDetail;
